import RouterPage from '../interfaces/RouterPage';
import { UserRoleEnum } from '../enums/UserRoleEnum';
import { translate } from './translation';
import RouterPageContext from 'interfaces/RouterPageContext';

export const routerPages: RouterPage[] = [
  {
    hasDivider: false,
    href: '/files/personal',
    icon: 'FolderIcon',
    isDisabled: false,
    isHidden: false,
    key: 'files',
    label: translate('common.files'),
    notificationsCount: 0,
    condition: (context) => {
      return [UserRoleEnum.Admin, UserRoleEnum.Contributor].includes(
        context.authenticatedUser?.role || UserRoleEnum.Reader
      );
    },
  },
  {
    hasDivider: false,
    href: '/files/received',
    icon: 'FileDownIcon',
    isDisabled: false,
    isHidden: false,
    key: 'received',
    label: translate('common.received'),
    notificationsCount: 0,
  },
  {
    hasDivider: false,
    href: '/files/shared',
    icon: 'FileUserIcon',
    isDisabled: false,
    isHidden: false,
    key: 'shared',
    label: translate('common.shared'),
    notificationsCount: 0,
    condition: (context) => {
      return [UserRoleEnum.Admin, UserRoleEnum.Contributor].includes(
        context.authenticatedUser?.role || UserRoleEnum.Reader
      );
    },
  },
  {
    hasDivider: false,
    href: '/files/favorites',
    icon: 'StarIcon',
    isDisabled: false,
    isHidden: false,
    key: 'favorites',
    label: translate('common.favorites'),
    notificationsCount: 0,
  },
  {
    hasDivider: false,
    href: '/files/hidden',
    icon: 'ArchiveIcon',
    isDisabled: false,
    isHidden: false,
    key: 'archive',
    label: translate('common.hidden'),
    notificationsCount: 0,
  },
  {
    hasDivider: true,
    href: '/files/trash',
    icon: 'TrashIcon',
    isDisabled: false,
    isHidden: false,
    key: 'trash',
    label: translate('common.trash'),
    notificationsCount: 0,
    condition: (context) => {
      return [UserRoleEnum.Admin, UserRoleEnum.Contributor].includes(
        context.authenticatedUser?.role || UserRoleEnum.Reader
      );
    },
  },
  {
    hasDivider: false,
    href: '/users',
    icon: 'UserIcon',
    isDisabled: false,
    isHidden: false,
    key: 'users',
    label: translate('common.users'),
    notificationsCount: 0,
    condition: (context) => {
      return [UserRoleEnum.Admin, UserRoleEnum.Contributor].includes(
        context.authenticatedUser?.role || UserRoleEnum.Reader
      );
    },
  },
  {
    hasDivider: true,
    href: '/groups',
    icon: 'UsersIcon',
    isDisabled: false,
    isHidden: false,
    key: 'groups',
    label: translate('common.groups'),
    notificationsCount: 0,
    condition: (context) => {
      return [UserRoleEnum.Admin, UserRoleEnum.Contributor].includes(
        context.authenticatedUser?.role || UserRoleEnum.Reader
      );
    },
  },
  {
    hasDivider: true,
    href: '/settings',
    icon: 'SettingsIcon',
    isDisabled: false,
    isHidden: false,
    key: 'settings',
    label: translate('common.settings'),
    notificationsCount: 0,
    condition: (context) => {
      return [UserRoleEnum.Admin].includes(
        context.authenticatedUser?.role || UserRoleEnum.Reader
      );
    },
  },
];

if (import.meta.env.VITE_APP_STORE_ENABLED === 'true') {
  routerPages.push({
    hasDivider: true,
    href: '/sales-dashboard',
    icon: 'StoreIcon',
    isDisabled: false,
    isHidden: false,
    key: 'sales-dashboard',
    label: translate('store.sales-dashboard'),
    notificationsCount: 0,
    condition: (context) => {
      return [UserRoleEnum.Admin].includes(
        context.authenticatedUser?.role || UserRoleEnum.Reader
      );
    },
  });
}

export function filteredRouterPages(context: RouterPageContext): RouterPage[] {
  return routerPages.filter((page) => {
    if (page.condition) {
      return page.condition(context);
    }
    return true;
  });
}
